import React, { useEffect, useState } from "react"
import { Button, TextField, Box, Grid } from "@material-ui/core"
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { Helmet } from "react-helmet"
import styles from "./handlereservation.module.scss"

interface ReserveResponse {
  isValid: boolean,
  invalidReason: string
}

const HandleReservationPage = () => {
  const [handle, setHandle] = useState<string>("")
  const [digits, setDigits] = useState<string>("")
  const [reserveResponse, setReserveResponse] = useState<ReserveResponse>()
  const [error, setError] = useState<boolean>(false)

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#ec3bdf",
      }
    },
  });

  const requestHandleReservation = async () => {
    try {
      setError(false);
      setReserveResponse(undefined);
      const response = await fetch("https://app.mayk.it/reserveUserHandleWithoutAuth", {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ handle: handle, digits: digits })
      });
      setReserveResponse(await response.json());
    } catch (error) {
      setError(true)
      console.log("Error getting user:", error)
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <title>mayk waitlist</title>
      </Helmet>
      <Grid
        alignItems='center'
        justify='center'
        container
        direction='column'
        className={styles.grid}
      >
        {headerContent()}
        <Box className={styles.rootCard}>
          {welcomeContent()}
          <form>
            <TextField
                      required
                      label='Phone Number'
                      style={{ width: "100%", marginBottom: 8 }}
                      onChange={e => setDigits(e.currentTarget.value)}
                    />
            <TextField
                      required
                      label='User Handle'
                      style={{ width: "100%", marginBottom: 24 }}
                      onChange={e => setHandle(e.currentTarget.value)}
                    />
            <Button
              variant="contained"
              color="primary"
              onClick={requestHandleReservation}
            >Reserve Handle</Button>
            {resultContent(reserveResponse, error)}
          </form>
          {footerContent()}
        </Box>
      </Grid>
    </ThemeProvider>
  )
}

const resultContent = (response: ReserveResponse|undefined, error: boolean) => {
  if (!response && !error) {
    return (
      <></>
    );
  }
  const isSuccess = response && response.isValid && !error;
  const defaultErrorText = "Failed to reserve this handle. Try again?";
  const text = isSuccess ? "✅ Reserved Handle!" : `❌ ${response?.invalidReason || defaultErrorText}`; 
  return (
    <p className={isSuccess ? styles.successResultText : styles.errorResultText}>
      {text}
    </p>
  )
}

const headerContent = () => {
  return (
    <Box justifyContent='center' display='flex' alignItems='center'>
        <img src={process.env.PUBLIC_URL + "/logo.png"} alt='logo' className={styles.maykLogo} />
        <h3 className={styles.maykTitle}>mayk</h3>
    </Box>
  )
}

const welcomeContent = () => {
  return (
    <Box
      flexDirection='column'
      justifyContent='center'
      display='flex'
      alignItems='center'>
        <p className={styles.welcomeHeader}>Join the mayk waitlist and reserve your handle now!</p>
        <p className={styles.phoneNumberNote}>Note: When you get the app, you'll need to sign up with the same phone number to claim your handle.</p>
    </Box>
  )
}

const footerContent = () => {
  return (
    <Box
      className={styles.footer}
      justifyContent='center'
      display='flex'
      alignItems='center'
      flexDirection='column'>
        <p>*By signing up for our limited waitlist and beta with your phone you agree to us reaching out to you for feedback</p>
        <Box justifyContent='space-around' display='flex' width="100%">
          <a href="https://www.mayk.it/privacy" target="_blank" className={styles.privacyLink}>Privacy Policy</a>
          <a href="https://www.mayk.it/terms-of-service" target="_blank" className={styles.privacyLink}>Terms and Conditions</a>
        </Box>
    </Box>
  )
}

export default HandleReservationPage
